import { createElement as rc, forwardRef } from 'react';
import useFormControl from '../../hooks/useFormControl';
import { styled } from 'lib_ui-primitives';
import FormField from './FormField';
import PropTypes from 'prop-types';
import { Text } from 'lib_ui-primitives';

const StyledText = styled(Text)`
    flex-grow: 1;
`;

const _p = {
    useFormControl
};
export const _private = _p;

const ReadOnlyText = forwardRef(function ReadOnlyText(props, ref) {
    const {
        hNode,
        hNode: {
            id,
            propertyName,
            rows,
            treePosition: { sequence }
        },
        multiline,
        style
    } = props;

    const { title, value } = _p.useFormControl(props);
    const fieldEmpty = value === '';

    // prettier-ignore
    return rc(FormField, { hNode, title, fieldEmpty, style },
        rc(StyledText, {
            hNode,
            ref,
            id,
            name: propertyName,
            multiline,
            rows,
            value,
            sequence,
            'aria-label': title
        }, value ? String(value) : '')  // need to ensure value is a string for Text component
    );
});
ReadOnlyText.propTypes = {
    hNode: PropTypes.shape({
        treePosition: PropTypes.shape({
            sequence: PropTypes.number.isRequired
        }).isRequired
    }).isRequired,
    multiline: PropTypes.bool
};

export default ReadOnlyText;
